"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.closeResultAccount = exports.getProcessActionsTx = exports.getMainActionTxIndex = exports.addActionsToConstruction = void 0;
const anchor_1 = require("@project-serum/anchor");
const spl_token_1 = require("@solana/spl-token");
const web3_js_1 = require("@solana/web3.js");
const __1 = require("..");
const solana_1 = require("../utils/solana");
const helpers_1 = require("./helpers");
let ADD_ACTION_INST_IDL;
/**
 * Create the instructions for adding actions. If the actions array is too large,
 * split this into multiple transactions
 *
 * if skipInTokenCheck is true in the opts, then the in token account will not be added on chain
 * and the check will be skipped
 */
const addActionsToConstruction = (program, construction, actions, authority) => {
    ADD_ACTION_INST_IDL = __1.MallocIdl.instructions.find((i) => i.name === "addActions");
    const actionInfos = actions.map(actionToActionsWithVertexInfo);
    const createTxFn = (items) => createAddActionsTx(program, construction, items, authority);
    return (0, helpers_1.breakUpInstrDataArrays)(actionInfos, createTxFn);
};
exports.addActionsToConstruction = addActionsToConstruction;
const actionToActionsWithVertexInfo = (action) => {
    var _a;
    const findIdx = (pk, isOutput) => {
        const idx = action.actionAccounts.findIndex((account) => account.address.equals(pk));
        if (idx === -1)
            throw `Expected to find ${isOutput ? "output" : "input"} token ${pk.toBase58()} in ${action.actionName}'s accounts`;
        return idx;
    };
    const inputTokenIdxs = action.inputTokenAccounts.map((pk) => findIdx(pk, false));
    const outputTokenIdxs = action.tokenAccountOuts.map((pk) => findIdx(pk, true));
    return {
        inDegree: action.actionVertexInfo.inDegree,
        inputTokenIdxs,
        outputTokenIdxs,
        numberInputMints: action.inputTokenAccounts.length,
        minOuts: ((_a = action.actionVertexInfo.minOuts) === null || _a === void 0 ? void 0 : _a.map((minOut) => new anchor_1.BN(minOut))) || null,
        nextNodes: action.actionVertexInfo.nextNodes.map((nextNode) => nextNode.map((n) => {
            return {
                actionIdx: n.actionIdx,
                fraction: new spl_token_1.u64(n.fraction),
                nextInputMintIdx: n.nextInputMintIdx,
            };
        })),
    };
};
const createAddActionsTx = (program, construction, actions, authority) => {
    const signers = authority.secretKey ? [authority] : [];
    return {
        tx: program.transaction.addActions(actions, (0, helpers_1.getRandomNotCryptoSecureNonce)(0, 0xffffffff), {
            accounts: {
                authority: authority.publicKey,
                construction: construction,
                rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
            },
            signers: signers,
        }),
        signers,
    };
};
/**
 * out of all the transactions associated with the action call,
 * get the index of the tx which does the actual action call
 */
const getMainActionTxIndex = (action) => {
    var _a, _b;
    const offset = ((_b = (_a = action.opts) === null || _a === void 0 ? void 0 : _a.preActionTxs) !== null && _b !== void 0 ? _b : []).length;
    return offset;
};
exports.getMainActionTxIndex = getMainActionTxIndex;
// export const initAllActionResultAccounts = async (
//   provider: Provider,
//   actions: Action[],
//   authority: Wallet | Signer,
// ): Promise<ResultAccountRet> => {
//   const ret: ResultAccountRet = {};
//   const maxIdxTokenOuts: { [pid: string]: number } = {};
//   // Get all the max idxs
//   actions.forEach((a, actionIdx) => {
//     const PID = a.actionProgram.toBase58();
//     const tokMintsOut = a.tokenMintOuts.length;
//     if (!maxIdxTokenOuts[PID]) {
//       maxIdxTokenOuts[PID] = actionIdx;
//     } else if (
//       actions[maxIdxTokenOuts[PID]].tokenMintOuts.length < tokMintsOut
//     ) {
//       maxIdxTokenOuts[PID] = actionIdx;
//     }
//   });
//   // Create the transactions
//   await Promise.all(
//     Object.keys(maxIdxTokenOuts).map(async (pid) => {
//       if (!preferredResultAccounts || !preferredResultAccounts[pid]) {
//         const actionProg = getActionIdlDummyProgram(
//           provider,
//           new PublicKey(pid)
//         );
//         const numbTokOuts = actions[maxIdxTokenOuts[pid]].tokenMintOuts.length;
//         ret[pid] = await initActionResultAccount(
//           actionProg,
//           numbTokOuts,
//           authority
//         );
//       } else {
//         ret[pid] = {
//           resultAccount: preferredResultAccounts[pid],
//         };
//       }
//     })
//   );
//   return ret;
// };
// const initActionResultAccount = async (
//   actionTemplateProgram: Program,
//   numberOfPossibleOutputTokens: number,
//   authority: Wallet | Signer
// ): Promise<{ tx: SendTxRequest; resultAccount: Signer }> => {
//   const result = Keypair.generate();
//   const signers = (authority as Signer).secretKey
//     ? [authority as Signer, result]
//     : [result];
//   actionTemplateProgram.provider.connection.getMinimumBalanceForRentExemption;
//   const resultSize = calcSizeResultAccount(numberOfPossibleOutputTokens);
//   const tx = actionTemplateProgram.transaction.initResultAccount(
//     numberOfPossibleOutputTokens,
//     {
//       accounts: {
//         result: result.publicKey,
//         owner: authority.publicKey,
//         rent: web3.SYSVAR_RENT_PUBKEY,
//       },
//       instructions: [
//         await SystemProgram.createAccount({
//           fromPubkey: actionTemplateProgram.provider.wallet.publicKey,
//           newAccountPubkey: result.publicKey,
//           space: resultSize,
//           lamports: calculateRent(resultSize, LIFETIME_RESULT_ACCOUNT_MS),
//           programId: actionTemplateProgram.programId,
//         }),
//       ],
//       signers,
//     }
//   );
//   return {
//     tx: { tx, signers },
//     resultAccount: result,
//   };
// };
// 8 for the discriminator, 32 for the owner pubkey, 4 for the number of results, and the rest for numb actions, then 64 as a buffer
const calcSizeResultAccount = (numberOfActions) => 8 + 32 + 4 + numberOfActions * 8 + 64;
const getProcessActionsTx = (program, actionIdxs, construction, actionAccountsCtx, authority, opts) => {
    const processRets = actionAccountsCtx.map((ctx, i) => getProcessSingleActionInstr(program, actionIdxs[i], construction, actionAccountsCtx[i], authority, opts[i]));
    const instsPrior = opts
        .map((opt) => opt.instructions)
        .filter((x) => x)
        .flat();
    const processInsts = [...instsPrior, ...processRets.map((p) => p.inst)];
    const processSigners = processRets.map((p) => p.signers);
    const allSigners = processSigners.flat();
    const tx = new web3_js_1.Transaction();
    tx.add(...processInsts);
    const sendTxProc = {
        tx,
        signers: (0, solana_1.removeSignerDuplicates)(allSigners),
    };
    return [
        ...opts
            .map((opt) => opt.preActionTxs)
            .filter((tx) => !!tx)
            .flat(),
        sendTxProc,
    ];
};
exports.getProcessActionsTx = getProcessActionsTx;
/**
 * @param tokenAuthority - defaults to the authority if not provided
 */
const getProcessSingleActionInstr = (program, actionIdx, construction, actionAccountsCtx, authority, opts) => {
    var _a, _b;
    const auth = ((_a = authority) === null || _a === void 0 ? void 0 : _a.secretKey) ? [authority] : [];
    const tokauth = ((_b = opts.tokenAuthority) === null || _b === void 0 ? void 0 : _b.secretKey)
        ? [opts.tokenAuthority]
        : [];
    const signersIsolated = opts.tokenAuthority
        ? [...tokauth, ...auth]
        : [...auth];
    const signers = [...signersIsolated, ...(opts.additionalSigners || [])];
    const inst = program.instruction.processAction(actionIdx, opts.data || Buffer.from([]), {
        accounts: {
            construction: construction,
            rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
            authority: authority.publicKey,
            actionCtxProxy: actionAccountsCtx.ctx,
            actionAccounts: actionAccountsCtx.actionAccounts,
        },
        signers,
    });
    return { inst, signers };
};
const closeResultAccount = (actionTemplateProgram, resultAccount, solRecipient, authority) => {
    const signers = authority.secretKey ? [authority] : [];
    actionTemplateProgram.provider.connection.getMinimumBalanceForRentExemption;
    const tx = actionTemplateProgram.transaction.closeResultAccount({
        accounts: {
            resultAccount,
            owner: authority.publicKey,
            recipient: solRecipient,
        },
        signers,
    });
    return {
        tx,
        signers,
    };
};
exports.closeResultAccount = closeResultAccount;
